<div class="modal-backdrop" (click)="onCancel()"></div>
<div class="modal">
  <div class="modal-header">
    <h3>{{ 'edit_driver_data_dialog.title' | translate }}</h3>
  </div>
  <div class="modal-body">
    <label>
      <span>{{ 'drivers.username' | translate }}</span>
      <input type="text" [value]="username" disabled />
    </label>

    <label class="checkbox-row">
      <input type="checkbox" [(ngModel)]="clearWelcome" [disabled]="submitting" />
      <span>{{ 'edit_driver_data_dialog.clear_welcome' | translate }}</span>
    </label>

    <label class="checkbox-row">
      <input type="checkbox" [(ngModel)]="clearDisclosure" [disabled]="submitting" />
      <span>{{ 'edit_driver_data_dialog.clear_disclosure' | translate }}</span>
    </label>

    <label>
      <span>{{ 'edit_driver_data_dialog.truck_id' | translate }}</span>
      <input type="text" [(ngModel)]="draftTruckId" [placeholder]="'edit_driver_data_dialog.truck_id_placeholder' | translate" [disabled]="submitting" />
    </label>
  </div>
  <div class="modal-footer">
    <button class="button secondary" type="button" (click)="onCancel()" [disabled]="submitting">{{ 'edit_driver_data_dialog.cancel' | translate }}</button>
    <button class="button" type="button" (click)="onSubmit()" [disabled]="submitting">{{ 'edit_driver_data_dialog.continue' | translate }}</button>
  </div>
</div>


